import EventEmitter from 'events';

export class AsyncIterator extends EventEmitter {
  _list: any[];
  _limit: number;
  _times: number;
  _interval: number;
  _iterator: (item: any, done: (err?: any) => void) => void;
  _errorFilter: (err: any, list_item: any) => boolean;
  _errorList: any[];
  _doneList: any[];
  _lastFinishTime: number[];
  _runningList: any[];
  _nextStart: number;
  constructor(params) {
    super();
    this._list = params.list;
    this._limit = params.limit || 1;
    this._times = params.times || 1;
    this._interval = params.interval || 0;
    this._iterator = params.iterator;
    this._errorFilter = params.errorFilter || _returnTrue;
    this._errorList = this._list.map(() => []);
    this._doneList = this._list.map(() => false);
    this._lastFinishTime = this._list.map(() => 0);
    this._runningList = [];
    this._nextStart = 0;
  }
  start() {
    this._maybeRun();
  }

  _isAllDone() {
    let ret = true;
    for (let i = 0; i < this._list.length; i++) {
      const error_count = this._errorList[i].length;
      const is_done = this._doneList[i];
      if (!is_done && error_count < this._times) {
        ret = false;
        break;
      }
    }
    return ret;
  }

  _getNext() {
    let ret;
    if (this._runningList.length >= this._limit) {
      ret = false;
    } else {
      const length = this._list.length;
      for (let i = 0; i < length; i++) {
        const index = (this._nextStart + i + 1) % length;
        const list_item = this._list[index];
        const is_done = this._doneList[index];
        const is_running =
          this._runningList.findIndex((running) => running === index) >= 0;
        if (!is_running && !is_done) {
          const delta = Date.now() - this._lastFinishTime[index];
          const delay = Math.max(this._interval - delta, 0);
          ret = { index, list_item, delay };
          this._nextStart = (index + 1) % length;
          break;
        }
      }
    }
    return ret;
  }
  _maybeRun() {
    if (this._isAllDone()) {
      this.emit('done');
    } else {
      for (;;) {
        const next = this._getNext();
        if (!next) {
          break;
        }
        this._run(next);
      }
    }
  }
  _run(next) {
    const { index, list_item, delay } = next;
    this._runningList.push(index);
    setTimeout(() => {
      this.emit('item_starting', list_item);
      this._iterator(list_item, (err) => {
        this._lastFinishTime[index] = Date.now();
        const found = this._runningList.findIndex(
          (running) => running === index
        );
        if (found >= 0) {
          this._runningList.splice(found, 1);
        }
        if (err) {
          const error_list = this._errorList[index];
          error_list.push(err);
          this.emit('item_error', err, list_item);
          const error_count = error_list.length;
          const hit_error_limit = error_count >= this._times;
          const should_continue =
            !hit_error_limit && this._errorFilter(err, list_item);
          if (!should_continue) {
            this.emit('item_final_error', err, list_item);
            this._doneList[index] = true;
          }
        } else {
          this._doneList[index] = true;
          this.emit('item_done', list_item);
        }
        this._maybeRun();
      });
    }, delay);
  }
}

function _returnTrue() {
  return true;
}
